import { USERS_AND_ROLES } from '../../../../../../api/endpoints';
import request from '../../../../../../api/request';
import {
  CreateAdminAccountBody,
  IdentificationQuery,
  SearchAdminAccount,
  UpdateAdminAccountBody,
} from '../types';

export const searchAdminAccount = (query: IdentificationQuery) => {
  return request<SearchAdminAccount>(USERS_AND_ROLES.SEARCH_ADMIN_ACCOUNT, {
    params: query,
  });
};

export const createAdminAccount = (data: CreateAdminAccountBody) => {
  return request<{ data: { id: number } }>(
    USERS_AND_ROLES.POST_CREATE_ADMIN_ACCOUNT,
    {
      method: 'POST',
      data,
    },
  );
};

export const updateAdminAccount = (
  id: number,
  data: UpdateAdminAccountBody,
) => {
  return request<SearchAdminAccount>(USERS_AND_ROLES.UPDATE_ADMIN_ACCOUNT(id), {
    method: 'PUT',
    data,
  });
};

export const deleteAdminAccount = (id: number) => {
  return request<SearchAdminAccount>(
    USERS_AND_ROLES.PUT_ADMIN_ACCOUNT_STATUS(id),
    { method: 'PUT' },
  );
};

export const enableAdminAccount = (id: number) => {
  return request<SearchAdminAccount>(
    USERS_AND_ROLES.PUT_ADMIN_ACCOUNT_STATUS(id),
    { method: 'PUT' },
  );
};
